/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNotificationStatsResponse } from '../../models/get-notification-stats-response';

export interface GetNotificationStats$Params {
}

export function getNotificationStats(http: HttpClient, rootUrl: string, params?: GetNotificationStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationStatsResponse>> {
  const rb = new RequestBuilder(rootUrl, getNotificationStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNotificationStatsResponse>;
    })
  );
}

getNotificationStats.PATH = '/notifications/stats';
